module.exports = __webpack_public_path__ + "static/media/astronaut-arrow.36ed278d.svg";